<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="content-page">
    <div class="content vendor-profile">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/invoices">Invoices</a>
            </span>
          </div>
          <div class="info-pane mb-3">
            <p>The Vendor Master Data is currently not editable.</p>
                    <p>
                        If you find any discrepancies in the data below, please
                        reach out to the Location buyer for necessary updation.
                    </p>
          </div>
          <ng-container *ngIf="loading">
            <div class="text-center">
              <app-loader></app-loader>
            </div>
          </ng-container>
          <ng-container *ngIf="!loading">
            <div class="row">
              <div class="col-md-6">
                <div class="data-pane mb-4">
                  <h5 class="mb-2">Vendor Personal Details</h5>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="data-tag mb-4">
                        <h6>Vendor Name</h6>
                        <p>
                          {{ vendorData.supplierNm }}
                        </p>
                        <p *ngIf="vendorData.supplierNm === ''">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Country</h6>
                        <p>
                          {{ vendorData.cntryNm }}
                        </p>
                        <p *ngIf="vendorData.cntryNm === ''">Not available</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="data-tag mb-4">
                        <h6>Vendor Code</h6>
                        <p>
                          {{ vendorData.supplierCode }}
                        </p>
                        <p *ngIf="vendorData.supplierCode === ''">Not available</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="data-pane mb-4">
                  <h5 class="mb-2">Vendor Contact Details</h5>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="data-tag mb-4">
                        <h6>Postal Code</h6>
                        <p>
                          {{ vendorData.postalCode }}
                        </p>
                        <p *ngIf="vendorData.postalCode === ''">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Region</h6>
                        <p *ngIf="vendorData.region !== null">
                          {{ vendorData.region }}
                        </p>
                        <p *ngIf="vendorData.region === null || vendorData.region === ''">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>City</h6>
                        <p>
                          {{ vendorData.city }}
                        </p>
                        <p *ngIf="vendorData.city === ''">Not available</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="data-tag mb-4">
                        <h6>Email Address</h6>
                        <p>
                          {{ vendorData.email }}
                        </p>
                        <p *ngIf="vendorData.email === ''">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Contact Number</h6>
                        <p>
                          {{ vendorData.mobile }}
                        </p>
                        <p *ngIf="vendorData.mobile === ''">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Address</h6>
                        <p>
                          {{ vendorData.addrLine1 }}
                        </p>
                        <p *ngIf="vendorData.addrLine1 === ''">Not available</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="data-pane mb-2">
                  <h5 class="mb-2">Vendor Bank Details</h5>

                  <table aria-describedby="bank-details" class="table mb-0 toggle-arrow-tiny tablet breakpoint bank-details">
                    <thead>
                      <tr>
                        <th>Bank Name</th>

                        <th>Bank Country</th>

                        <th>Account No.</th>
                        <th>Account Holder</th>
                        <th>IFSC Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="footable-even footable-detail-show" *ngFor="let bank of vendorData.bankDetails">
                        <td *ngIf="bank.bankName !== ''">
                          {{ bank.bankName }}
                        </td>
                        <td *ngIf="bank.bankName === ''">NA</td>

                        <td *ngIf="bank.bankCounty !== ''">
                          {{ bank.bankCounty }}
                        </td>
                        <td *ngIf="bank.bankCounty === ''">NA</td>
                        <td *ngIf="bank.accountNo !== ''">
                          {{ bank.accountNo }}
                        </td>
                        <td *ngIf="bank.accountNo === ''">NA</td>
                        <td *ngIf="bank.accountHolder !== ''">
                          {{ bank.accountHolder }}
                        </td>
                        <td *ngIf="bank.accountHolder === ''">NA</td>
                        <td *ngIf="bank.IFSC !== ''">
                          {{ bank.IFSC }}
                        </td>
                        <td *ngIf="bank.IFSC === ''">NA</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-6">
                <div class="data-pane pb-4 p5-2">
                  <h5 class="mb-2">Vendor Statutory Details</h5>
                  <div class="row">
                    <div class="col-md-6 py">
                      <div class="data-tag mb-4">
                        <h6>PAN Number</h6>
                        <p>
                          {{ vendorData.panNo }}
                        </p>
                        <p *ngIf="vendorData.panNo === ''">Not available</p>
                      </div>
                      <div class="data-tag mb-4">
                        <h6>Tax Registration Number</h6>
                        <p *ngIf="vendorData.gstin === ''">Not available</p>
                        <p *ngIf="vendorData.gstin !== ''">
                          {{ vendorData.gstin }}
                        </p>
                      </div>
                      <div class="data-tag mb-4">
                        <h6>Tax Registration Status</h6>
                        <p>
                          {{ vendorData.gstinStatus }}
                        </p>
                        <p *ngIf="vendorData.gstinStatus === ''">Not available</p>
                      </div>
                      <div class="data-tag mb-4">
                        <h6>IRN E-invoice status</h6>
                        <p>
                          {{ vendorData.eInvoiceStatus }}
                        </p>
                        <p *ngIf="vendorData.eInvoiceStatus === ''">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Tax Return Filing Status</h6>
                        <p *ngIf="statusExist">
                          {{ vendorData.taxReturnStatus }}
                        </p>
                        <p *ngIf="!statusExist">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Tax Return Filing Frequency</h6>
                        <p *ngIf="freqExist">
                          {{ vendorData.taxReturnFrequency }}
                        </p>
                        <p *ngIf="!freqExist">Not available</p>
                      </div>

                      <div class="data-tag mb-4">
                        <h6>Last Tax Filing Date</h6>
                        <p *ngIf="vendorData.vendor_gstr_filing_date !== ''">
                          {{ vendorData.gstinFillingDate }}
                        </p>
                        <p *ngIf="vendorData.vendor_gstr_filing_date === ''">Not available</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="data-tag mb-4">
                        <h6>Industry</h6>
                        <p *ngIf="vendorData.industry !== null">
                          {{ vendorData.industry }}
                        </p>
                        <p *ngIf="vendorData.industry === null">Not available</p>
                      </div>
                      <div class="data-tag mb-4">
                        <h6>URN Number</h6>
                        <p *ngIf="vendorData.unrNo !== ''">
                          {{ vendorData.unrNo }}
                        </p>
                        <p *ngIf="vendorData.unrNo === ''">Not available</p>
                      </div>
                      <div class="data-tag mb-4">
                        <h6>MSME Validity Start Date</h6>
                        <p *ngIf="vendorData.msmeStartDate !== ''">
                          {{ vendorData.msmeStartDate }}
                        </p>
                        <p *ngIf="vendorData.msmeStartDate === ''">Not available</p>
                      </div>
                      <div class="data-tag mb-4">
                        <h6>MSME Validity End Date</h6>
                        <p *ngIf="vendorData.msmeEndDate !== ''">
                          {{ vendorData.msmeEndDate }}
                        </p>
                        <p *ngIf="vendorData.msmeEndDate === ''">Not available</p>
                      </div>
                      <!-- <div class="td-codes" *ngFor="let td_code of vendorData.bankDetails; let lastItem = last">
                        <div class="data-tag mb-4" *ngIf="td_code.tds_code_section !== ''">
                          <h6>TDS Codes Applicable - Section</h6>
                          <p>
                            {{ td_code.tds_code_section }}
                          </p>
                        </div>
                        <div class="data-tag mb-4" *ngIf="td_code.tds_code_tax_code !== ''">
                          <h6>TDS Codes Applicable - Tax Code</h6>
                          <p>
                            {{ td_code.tds_code_tax_code }}
                          </p>
                        </div>
                        <hr *ngIf="!lastItem" />
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
